"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.conversionParametersFor = conversionParametersFor;
exports.collectResults = collectResults;
const property_1 = require("@genesys/property");
// Showing the outlet humidity as anything but a humidity ratio needs the air state it belongs to.
// CoilPro reports that state, so both readings come off the result itself - undefined when a coil
// type does not report them, which leaves the column in the quantity it arrived in.
function conversionParametersFor(result) {
    const pressure = property_1.PropertyValueSet.getAmount("pressureout", result);
    const temperature = property_1.PropertyValueSet.getAmount("temperatureout", result);
    return pressure && temperature ? { pressure, temperature } : undefined;
}
function collectResults(pvsData) {
    return Object.keys(pvsData).reduce((soFar, currentKey) => {
        const currentValue = pvsData[currentKey];
        return typeof currentValue === "string"
            ? property_1.PropertyValueSet.setText(currentKey, currentValue, soFar)
            : property_1.PropertyValueSet.setAmount(currentKey, currentValue, soFar);
    }, property_1.PropertyValueSet.Empty);
}
//# sourceMappingURL=functions.js.map